import { Component, OnInit, Input } from '@angular/core';
import { BreadcrumbsConfig } from '@exalif/ngx-breadcrumbs';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

  breadcrumbs: any = [];
  @Input() title: string;

  constructor() { }

  ngOnInit() {

    if (!this.breadcrumbs.length) {


      if (window.location.pathname.split('/')[1] == 'practicas') {
        this.breadcrumbs.push({
          text: "prácticas"
        });

        return
      } else {

        for (let i = 1; i < window.location.pathname.split('/').length; i++) {
          this.breadcrumbs.push({
            text: window.location.pathname.split('/')[i]
          });

        }

        return
      }


        if (this.title) {
          this.breadcrumbs.push({
            text: '#' + this.title
          });
        }


    }



  }

}
